import { render } from "./Curias.vue?vue&type=template&id=6df8c3b6&scoped=true"
import script from "./Curias.vue?vue&type=script&lang=js"
export * from "./Curias.vue?vue&type=script&lang=js"

import "./Curias.vue?vue&type=style&index=0&id=6df8c3b6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df8c3b6"]])

export default __exports__